//@ flow
const showToastMessage = (payload) => {
    const {
        message
    } = payload;
    window.dispatchEvent(
        new CustomEvent('toastMessageDisplayed', {
            detail: {
                payload: 'Toast message displayed successfully',
                stopLoading: true,
                type: 'success',
                message: message
            }
        })
    );
    return;
}

export default showToastMessage;
